export { ButtonStyled } from '@/components/atoms/Button/ButtonStyled';
